import { create } from 'zustand';

// Tracks whether the on-screen numeric keypad is currently visible. Used by
// AppShell to hide the bottom nav and by CreateEstimate to hide the sticky
// total bar — otherwise both would clip the keypad's bottom row on small
// viewports (keypad is ~280px tall, nav + total bar steal ~140px).
type KeypadOverlayState = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
};

export const useKeypadOverlayStore = create<KeypadOverlayState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
